import truncateUrl from './truncateUrl'

export default function externalLink(url: string, text?: string): string {
    if (!url) {
        return null
    }

    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${text || truncateUrl(url)}</a>`
}
